module.exports = __webpack_public_path__ + "static/media/change-pass-icon.244adbb1.svg";